import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../auth/auth.service';
import { Router, ActivatedRoute, NavigationEnd, Params } from '@angular/router';
import { LoginComponent } from 'src/app/modules/components/login/login.component';
import { filter, map } from 'rxjs/operators';
@Component({
  selector: 'app-poll-header',
  templateUrl: './poll-header.component.html',
  styleUrls: ['./poll-header.component.css']
})
export class PollHeaderComponent implements OnInit {
  poll_id = '-1';
  showCopy = false;
  pollLink;
  constructor(private dialog: MatDialog, public auth: AuthService, private router: Router, private route: ActivatedRoute) {
    router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => this.getParams(this.route))
    ).subscribe(params => {
      if (params.id) {
        this.poll_id = params.id
      } else {
        this.poll_id = '-1';
      }
    });
  }

  ngOnInit(): void {
    
  }
  openLogin() {
    let dialogRef = this.dialog.open(LoginComponent, {
      height: '500px',
      width: '600px',
    })
    this.router.events
    .subscribe(() => {
      dialogRef.close();
    })
  }

  private getParams(route: ActivatedRoute): Params {
    // route param names (eg /a/:personId) must be ditinct within
    // a route otherwise they'll be overwritten
    let params = route.snapshot.params
    params = { ...route.snapshot.queryParams, ...params}
    if(route.children){
      for(let r of route.children){
        params = {...this.getParams(r), ...params};        
      }
    }
    return params;
  }
  
  
}
